import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import { getAccessToken } from '../api/client.js';

export default function OAuthAuthorizePage() {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (loading) return;

    if (!user) {
      const returnUrl = `/oauth/authorize?${searchParams.toString()}`;
      navigate(`/login?next=${encodeURIComponent(returnUrl)}`, { replace: true });
      return;
    }

    const token = getAccessToken();
    if (!token) {
      setError('No access token found. Please log in again.');
      return;
    }

    const params = new URLSearchParams({
      client_id: searchParams.get('client_id') || '',
      redirect_uri: searchParams.get('redirect_uri') || '',
      response_type: searchParams.get('response_type') || 'code',
      state: searchParams.get('state') || '',
      access_token: token,
    });

    window.location.href = `/api/oauth/authorize?${params.toString()}`;
  }, [loading, user]);

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ maxWidth: 400, textAlign: 'center', padding: 24 }}>
          <p style={{ color: '#c00', marginBottom: 16 }}>{error}</p>
          <a href="/login" style={{ color: '#e8590c' }}>Go to login</a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'ui-monospace, monospace', color: '#8a8373' }}>
      Redirecting…
    </div>
  );
}
